export default __webpack_public_path__ + "static/media/incubator.925563cd.svg";